<input ref="inputRef" type="text"/>